const hrcu_Communication_Block = function (robotType, blockSeparator, categorySeparator) {
    switch (robotType) {
        case 'E7':
            return `
            <category 
                name="%{BKY_CATEGORY_WIFI}"
                id="hrcu_communication"
                colour="#00d7b1" 
                secondaryColour="#00d7b1">
                
                <block type="hrcu_iot_setWifiData">
                    <value name="VALUE">
                        <shadow type="text">
                            <field name="TEXT">1</field>
                        </shadow>
                    </value>
                </block>
                <block type="hrcu_iot_getWifiData"/>
                <block type="hrcu_iot_setRcuBluetoothData">
                    <value name="VALUE">
                        <shadow type="text">
                            <field name="TEXT">50</field>
                        </shadow>
                    </value>
                </block>
                <block type="hrcu_iot_getRcuBluetoothData"/>
                <block type="hrcu_communication_GetPhoneWiFiYGData"/>
                <block type="hrcu_communication_IsPhoneWiFiBtnData"/>
                <block type="hrcu_communication_IsPhoneWiFiYGData"/>
                <block type="hrcu_communication_OpenCameraForPhone"/>
                <block type="hrcu_communication_SendWifiBtnDescribe">
                    <value name="VALUE">
                        <shadow type="textvalue">
                            <field name="TEXT"></field>
                        </shadow>
                    </value>
                </block>
                ${blockSeparator}
            </category>
                `;
        default:
            return `
                <category 
                    name="通讯" 
                    id="hrcu_iot"
                    colour="#00d7b1" 
                    secondaryColour="#00d7b1">
                </category>
                `;
    }
};

export default hrcu_Communication_Block;
